// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var input = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.darkGrey),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(3.75)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.rem(3.0)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(3)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.0)),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.rem(1.5)),
      BsCssJs$PrezzeeRibbon.border(BsCssJs$PrezzeeRibbon.px(0), "solid", "transparent"),
      BsCssJs$PrezzeeRibbon.outline(BsCssJs$PrezzeeRibbon.px(0), "solid", "transparent")
    ]);

var inputOpened = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderBottomLeftRadius(BsCssJs$PrezzeeRibbon.px(0)),
      BsCssJs$PrezzeeRibbon.borderBottomRightRadius(BsCssJs$PrezzeeRibbon.px(0)),
      BsCssJs$PrezzeeRibbon.borderBottomWidth(BsCssJs$PrezzeeRibbon.px(0))
    ]);

var Styles = {
  input: input,
  inputOpened: inputOpened
};

var make = React.memo(function (props) {
      var value = props.value;
      var onEnter = props.onEnter;
      var onKeyDown = React.useCallback((function (e) {
              var key = e.key;
              var keyCode = e.keyCode;
              if (key === "Enter" || keyCode === 13) {
                return Curry._1(onEnter, value);
              }
              
            }), [
            onEnter,
            value
          ]);
      return JsxRuntime.jsx("input", {
                  className: Classnames([
                        input,
                        props.listOpened ? inputOpened : ""
                      ]),
                  placeholder: props.placeholder,
                  value: value,
                  onKeyDown: onKeyDown,
                  onFocus: props.onFocus,
                  onChange: props.onChange
                });
    });

export {
  Styles ,
  make ,
}
/* input Not a pure module */
